module.exports = "https://cdn.dashboard.gifty.nl/5780/images/gifty-logo-light.png?3ef127ce0af1e3a1116c23f122a81b28";